// @flow
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import CarouselCards from '../CarouselCards/CarouselCards';
import QempoFullContent from '../QempoFullContent/QempoFullContent';
import QempoLiteContent from '../QempoLiteContent/QempoLiteContent';
import {UntilTablet} from '../../../../utils/responsive';

import style from './ShoppingCart.scss';

import type {ShoppingCartItem, User} from '../../../../entities';
import type { ForecastType, Forecast } from '../../../new-order/QuoteStep/api';

type Props = {
  user?: User;
  shoppingCart?: ShoppingCartItem[];
  isFetchingShoppingCart?: boolean;
  isDeletingItem?: boolean;
  isEditingItem?: boolean;
  fetchCheckoutDataSuccess: (forecast: Forecast, selectedIndex: number, 
    importMethod: ForecastType, shoppingCartItems?: ShoppingCartItem[]) => void;
  goToRedirect: (route: string) => void;
};

type GroupedShoppingCartItems = {[key: string]: ShoppingCartItem[]};

export default class ShoppingCart extends Component<Props> {
  
  componentDidMount() {
    const {user, shoppingCart, isFetchingShoppingCart, goToRedirect} = this.props;
    
    if (!user && !shoppingCart && !isFetchingShoppingCart) {
      // goToRedirect('/');
    }
  }

  groupShoppingCartItems = (shoppingCart?: ShoppingCartItem[]): [GroupedShoppingCartItems, GroupedShoppingCartItems] => {
    const qempoLiteItems = {};
    const qempoFullItems = {};

    if (shoppingCart) {
      shoppingCart.forEach((item: ShoppingCartItem) => {
        if (item.courier) {
          if (qempoLiteItems[item.courier.id])
            qempoLiteItems[item.courier.id].push(item);
          else
            qempoLiteItems[item.courier.id] = [item];
        } else {
          if (qempoFullItems[item.serviceTier])
            qempoFullItems[item.serviceTier].push(item);
          else
            qempoFullItems[item.serviceTier] = [item];
        }
      });
    }

    return [qempoFullItems, qempoLiteItems];
  };

  render() {
    const  {shoppingCart, isFetchingShoppingCart, isDeletingItem, isEditingItem, fetchCheckoutDataSuccess} = this.props;
    const [qempoFullItems, qempoLiteItems] = this.groupShoppingCartItems(shoppingCart);

    if (!isFetchingShoppingCart && shoppingCart && shoppingCart.length === 0) {
      <Redirect to="/" />
    }
    
    return (
      <div className={style.shoppingCartRoot}>
        <CarouselCards />

        <div className={style.bodyWrap}>
          <div className={style.titleWrap}>
            <div className={style.contentWrap}>
              <h4>Mi Carrito</h4>
              <UntilTablet>
                <Link to="/" className={style.linkMobile}>
                  Añadir más productos
                </Link>
              </UntilTablet>
            </div>

            <div className={style.subtitleWrap}>
              <span>
                Deberás realizar los pagos de Qempo Full y Qempo Lite por
                separado.
              </span>
              <Link to="/" className={style.link}>
                Añadir más productos
              </Link>
            </div>
          </div>

          <div className={style.cardItemsWraps}>
            <div className={style.bodyContainer}>
              {(!isFetchingShoppingCart && qempoFullItems) &&
                Object.keys(qempoFullItems).map((key) => (
                  <QempoFullContent
                    key={key}
                    subtype={key}
                    items={qempoFullItems[key]}
                    isFetchingShoppingCart={isFetchingShoppingCart}
                    isDeletingItem={isDeletingItem}
                    isEditingItem={isEditingItem}
                    fetchCheckoutDataSuccess={fetchCheckoutDataSuccess}
                  />
                ))}
              {(!isFetchingShoppingCart && qempoLiteItems) &&
                Object.keys(qempoLiteItems).map((key) => (
                    <QempoLiteContent
                      key={key}
                      subtype={key}
                      items={qempoLiteItems[key]}
                      isFetchingShoppingCart={isFetchingShoppingCart}
                      isDeletingItem={isDeletingItem}
                      isEditingItem={isEditingItem}
                      fetchCheckoutDataSuccess={fetchCheckoutDataSuccess}
                    />
                ))}
            </div>
          </div>

        </div>
      </div>
    );
  }
}

ShoppingCart.propTypes = {
  user: PropTypes.object,
  shoppingCart: PropTypes.array,
  isFetchingShoppingCart: PropTypes.bool,
  isDeletingItem: PropTypes.bool,
  isEditingItem: PropTypes.bool,
  fetchCheckoutDataSuccess: PropTypes.func.isRequired,
  goToRedirect: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/shopping-cart/components/ShoppingCart/ShoppingCart.jsx